import {
  Directive,
  effect,
  ElementRef,
  HostListener,
  inject,
  input,
  OnDestroy
} from '@angular/core';
import { Subscription } from "rxjs";
import { ScrollSyncService } from "../../core/services/table-services/scroll-sync.service";

@Directive({
  selector: '[appScrollSync]'
})
export class ScrollSyncDirective implements OnDestroy {
  sourceName = input.required<string>();
  syncGroup = input.required<string>();
  enabled = input<boolean>(true);

  private scrollSyncService: ScrollSyncService = inject(ScrollSyncService);
  private elementRef: ElementRef = inject(ElementRef);
  private subscription?: Subscription;

  private scrollSyncEffect = effect(() => {
    const enabled = this.enabled();
    const sourceName = this.sourceName();

    if (enabled && sourceName) {
      this.setupScrollSync();
    }
  });

  public ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: Event) {
    if (!this.enabled()) { return; }

    const scrollLeft = (event.target as HTMLElement).scrollLeft;
    this.scrollSyncService.scroll(this.sourceName(), scrollLeft, this.syncGroup());
  }

  private setupScrollSync(): void {
    this.subscription = this.scrollSyncService
      .getScrollEvents(this.sourceName(), this.syncGroup())
      ?.subscribe(event => {
        this.elementRef.nativeElement.scrollLeft = event.scrollLeft;
      });
  }
}
